export default class FormUtils {
  static getValidationErrors(vField, label, t) {
    const errors = [];
    if (!vField || !vField.$dirty) return errors;

    if ("required" in vField && !vField.required) {
      errors.push(t("validation_this_field_is_required", { label }));
    }
    if ("email" in vField && !vField.email) {
      errors.push(t("field_must_be_valid_email", { label }));
    }
    if ("url" in vField && !vField.url) {
      errors.push(t("field_must_be_valid_url", { label }));
    }
    if ("numeric" in vField && !vField.numeric) {
      errors.push(t("field_must_be_number", { label }));
    }

    return errors;
  }
}
